import clsx from 'clsx';
import { Button, Dropdown } from '@components';
import { XMarkIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { useDeal } from './context';
import { ListChecks, Building2, Hand, FileStack } from 'lucide-react';

export default function InternalDropdown({ buttonProps }) {
  const { setCurrentTaskItemFilter, currentTaskItemFilter } = useDeal();

  const buttonClasses =
    'flex items-center justify-center space-x-2 px-2.5 border-2 rounded-lg h-[54px]';
  const buttonColorClasses =
    'border-slate-200 text-slate-400 hover:text-slate-700 hover:border-slate-700';
  const buttonActiveColorClasses = 'border-blue-600 bg-blue-50 text-blue-600';
  const textClasses = 'flex items-center text-sm leading-[14px] font-hmedium';

  return (
    <div className="w-full xl:w-auto grid grid-cols-2 gap-2">
      <button
        className={clsx(
          buttonClasses,
          currentTaskItemFilter === 'INTERNAL' ? buttonActiveColorClasses : buttonColorClasses
        )}
        id="TRACKING"
        onClick={() => setCurrentTaskItemFilter('INTERNAL')}
      >
        <span>
          <ListChecks className="w-5 h-5" />
        </span>
        <span className={textClasses}>
          Fiche
          <br />
          de suivi
        </span>
      </button>
      <button
        id="DOCUMENTS"
        className={clsx(
          buttonClasses,
          currentTaskItemFilter === 'PUBLIC' ? buttonActiveColorClasses : buttonColorClasses
        )}
        onClick={() => setCurrentTaskItemFilter('PUBLIC')}
      >
        <span>
          <FileStack className="w-5 h-5" />
        </span>
        <span className={textClasses}>
          Gestion de
          <br />
          documents
        </span>
      </button>
    </div>
  );
}
